<template>
  <!-- container -->
  <div>
      <div class="form-group p-3">
        <label for="EventTitle">イベント名・イベントタイトル
          <span class="attention">※</span>
        </label>
        <input type="text" class="form-control" id="EventTitle" aria-required="true" placeholder="イベント名・イベントタイトル" v-model="event_name">
        <p class="error-msg" v-if="validation.event_name">{{ validation.event_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventTeacher">講師名（活動名）
          <span class="attention">※</span>
        </label>
        <input type="text" class="form-control" id="EventTeacher" aria-required="true" placeholder="講師名（活動名）" v-model="lecturer_name">
        <p class="error-msg" v-if="validation.lecturer_name">{{ validation.lecturer_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Event-date-input" class="col-form-label">開催日
          <span class="attention">※</span>
        </label>
        <textarea class="form-control" id="Event-date-input" aria-required="true" placeholder="開催日" rows="2" v-model="event_date"></textarea>
        <p class="error-msg" v-if="validation.event_date">{{ validation.event_date }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Event-date-public-input" class="col-form-label">開催日(一覧表示用)
          <span class="attention">※</span>
        </label>
        <input v-if="this.event_date_public" class="form-control" id="Event-date-public-input" aria-required="true" placeholder="1/1, 1/2, 1/3" v-model="event_date_public">
        <div v-if="!this.event_date_public">
          <div v-for="(val, key) in endDate" class="" style="margin-bottom: 10px;">
            <el-date-picker
              v-model="val.date"
              type="date"
              placeholder="選択してください"
              id="Event-date-public-input1"
              format="yyyy/MM/dd"
              v-bind:clearable="false"
              v-bind:editable="false"
            />
            <input class="btn btn-link" type="button" value="×" @click="deleteDateForm(key)">
          </div>
        </div>
        <p class="error-msg" v-if="validation.event_date_public">{{ validation.event_date_public }}</p>
        <div>
          <input v-if="!this.event_date_public" type="button" @click="addDateForm" value="追加" class="btn btn-sm btn-secondary">
        </div>
        <div v-if="!this.event_date_public">
          <p class="font-weight-bold">{{ eventEndDate }}</p>
        </div>
      </div>
      <div v-if="this.event_date_public"  class="form-group p-3">
        <label for="Event-dateEnd-input" class="col-form-label">掲載終了日</label>
        <input class="form-control" type="text" value="" id="Event-dateEnd-input" aria-required="true" placeholder="2017/01/01" v-model="end_date">
        <p class="error-msg" v-if="validation.end_date">{{ validation.end_date }}</p>
      </div>
      <div class="form-group p-3">
        <p for="EventPlace">開催場所・住所<span class="attention">※</span></p>
        <label for="EventPlace1">郵便番号</label>
        <input type="text" class="form-control mb-3" id="EventPlace1" aria-required="true" placeholder="103-0013" v-model="zipcode">
        <p class="error-msg" v-if="validation.zipcode">{{ validation.zipcode }}</p>
        <label for="EventPlace2">都道府県</label>
        <select class="form-control md-3" id="EventPlace2" aria-required="true" v-model="prefecture">
          <option value="">選択して下さい</option>
          <option>北海道</option>
          <option>青森県</option>
          <option>岩手県</option>
          <option>宮城県</option>
          <option>秋田県</option>
          <option>山形県</option>
          <option>福島県</option>
          <option>茨城県</option>
          <option>栃木県</option>
          <option>群馬県</option>
          <option>埼玉県</option>
          <option>千葉県</option>
          <option>東京都</option>
          <option>神奈川県</option>
          <option>山梨県</option>
          <option>新潟県</option>
          <option>富山県</option>
          <option>石川県</option>
          <option>福井県</option>
          <option>長野県</option>
          <option>岐阜県</option>
          <option>静岡県</option>
          <option>愛知県</option>
          <option>三重県</option>
          <option>滋賀県</option>
          <option>京都府</option>
          <option>大阪府</option>
          <option>兵庫県</option>
          <option>奈良県</option>
          <option>和歌山県</option>
          <option>鳥取県</option>
          <option>島根県</option>
          <option>岡山県</option>
          <option>広島県</option>
          <option>山口県</option>
          <option>徳島県</option>
          <option>香川県</option>
          <option>愛媛県</option>
          <option>高知県</option>
          <option>福岡県</option>
          <option>佐賀県</option>
          <option>長崎県</option>
          <option>熊本県</option>
          <option>大分県</option>
          <option>宮崎県</option>
          <option>鹿児島県</option>
          <option>沖縄県</option>
        </select>
        <p class="error-msg" v-if="validation.prefecture">{{ validation.prefecture }}</p>
        <label for="EventPlace3">市区郡町村</label>
        <input type="text" class="form-control mb-3" id="EventPlace3" aria-required="true" placeholder="中央区" v-model="city">
        <p class="error-msg" v-if="validation.city">{{ validation.city }}</p>
        <label for="EventPlace4">町・番地</label>
        <input type="text" class="form-control mb-3" id="EventPlace4" aria-required="true" placeholder="日本橋人形町2-4-9" v-model="address1">
        <p class="error-msg" v-if="validation.address1">{{ validation.address1 }}</p>
        <label for="EventPlace5">アパート・マンション・ビル名</label>
        <input type="text" class="form-control mb-3" id="EventPlace5" placeholder="双葉ビル802" v-model="address2">
        <p class="error-msg" v-if="validation.address2">{{ validation.address2 }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Event">会場名</label>
        <input type="text" class="form-control" id="Event" placeholder="会場名" v-model="venue_name">
        <p class="error-msg" v-if="validation.venue_name">{{ validation.venue_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventTel">問い合わせ先電話番号</label>
        <input type="tel" class="form-control" id="EventTel" placeholder="03-6231-0260" v-model="tel">
        <p class="error-msg" v-if="validation.tel">{{ validation.tel }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventMail">問い合わせ先メールアドレス
          <span class="attention">※</span>
        </label>
        <input type="mail" class="form-control" id="EventMail" aria-required="true" placeholder="info@ohirune.com" v-model="email">
        <p class="error-msg" v-if="validation.email">{{ validation.email }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventURL">会場ホームページ（アクセス方法）</label>
        <input type="url" class="form-control" id="EventURL" placeholder="http://ohiruneart.com" v-model="homepage">
        <p class="error-msg" v-if="validation.homepage">{{ validation.homepage }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventBlog">講師ホームページ・ブログ記事URL</label>
        <input type="url" class="form-control" id="EventBlog" placeholder="http://ohiruneart.com" v-model="lecturer_url">
        <p class="error-msg" v-if="validation.lecturer_url">{{ validation.lecturer_url }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventDes">イベントの詳細<span class="attention">※</span></label>
        <textarea class="form-control" id="EventDes" aria-required="true" placeholder="イベントの詳細" rows="6" v-model="description"></textarea>
        <p class="error-msg" v-if="validation.description">{{ validation.description }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventDes">参加費<span class="attention">※</span></label>
        <textarea class="form-control" id="EventPrice" aria-required="true" placeholder="参加費" rows="2" v-model="fee"></textarea>
        <p class="error-msg" v-if="validation.fee">{{ validation.fee }}</p>
      </div>
      <div class="form-group p-3">
        <label for="AppURL">お申し込みURL</label>
        <input type="url" class="form-control" id="AppURL" aria-required="true" placeholder="http://ohiruneart.com" v-model="entry_url">
        <p class="error-msg" v-if="validation.entry_url">{{ validation.entry_url }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventParking">駐車場有無</label>
        <select class="form-control" id="EventParking" v-model="parking">
                <option value="">選んで下さい...</option>
                <option>駐車場（有料）</option>
                <option>駐車場（無料）</option>
                <option>駐車場なし</option>
        </select>
        <p class="error-msg" v-if="validation.parking">{{ validation.parking }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventParking">撮影予定組数 （お客様には公開されません）<span class="attention">※</span></label>
        <select class="form-control" id="EventParking" aria-required="true" v-model="participant">
                <option value="">選んで下さい...</option>
                <option>50組未満</option>
                <option>51～100組</option>
                <option>101組～200組</option>
                <option>201組以上</option>
        </select>
        <p class="error-msg" v-if="validation.participant">{{ validation.participant }}</p>
      </div>
      <div class="form-group p-3">
        <label class="mr-sm-2" for="EventParking">主催者 （お客様には公開されません）<span class="attention">※</span></label>
        <select class="form-control" id="EventParking" aria-required="true" v-model="sponsor">
                <option value="">選んで下さい...</option>
                <option>あり</option>
                <option>なし</option>
        </select>
        <p class="error-msg" v-if="validation.sponsor">{{ validation.sponsor }}</p>
      </div>
      <div class="form-group p-3" v-if="sponsor === 'あり'">
        <label for="EventSponsor">主催者名 （お客様には公開されません）<span class="attention">※</span></label>
        <input type="text" class="form-control" id="EventSponsor" placeholder="主催者名" aria-required="true" v-model="sponsor_name">
        <p class="error-msg" v-if="validation.sponsor_name">{{ validation.sponsor_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="EventInputFile">イベント画像アップロード</label>
        <image-input id="EventInputFile"
          v-for="index in imageFormCount"
          :key="index"
          @image-changed="imageChanged(index, $event)"
          :index="index"
          :image="images[index-1]"
          />
        <small id="fileHelp" class="form-text text-muted">jpg,png のみ</small>
      </div>
      <div class="form-check mb-5 p-3">
        <label for="Event-public">公開有無<span class="attention">※</span></label>
        <select class="form-control" id="Event-public" aria-required="true" v-model="published">
          <option value="">選んで下さい...</option>
          <option>公開する</option>
          <option>公開しない</option>
        </select>
        <p class="error-msg" v-if="validation.published">{{ validation.published }}</p>
      </div>
  </div>
</template>

<script>
import ImageInput from 'components/lecturer/ImageInput'
import PrefectureSelector from 'components/PrefectureSelector'
import binder from 'store/event_form/binder'
import util from 'util/common'
import lecturer from 'util/lecturer'
const imageMaxCount = 2
binder.imageFormCount = function () {
  return Math.min(this.images.length + 1, imageMaxCount)
}
export default {
  components: {
    ImageInput,
    PrefectureSelector
  },

  props: ['validation'],

  data () {
    return {
      endDate: [
        {date: ''}
      ]
    }
  },
  created () {
    if (this.event_date_public_multi) {
      let l = this.event_date_public_multi.split(',')
      this.endDate.pop()
      l.forEach(k => {
        this.endDate.push({date: util.stringToDate(k)})
      })
    }
  },
  methods: {
    imageChanged (index, file) {
      let img = [...this.images]
      img[index - 1] = file
      img = img.filter(i => i !== '')
      this.$store.commit('updateImages', img)
    },
    addDateForm () {
      this.endDate.push({date: ''})
    },
    deleteDateForm (index) {
      if (this.endDate.length > 1) {
        this.endDate.splice(index, 1)
      }
      let newList = []
      this.endDate
        .filter(i => i.date !== '' || i.date === 'undefined')
        .forEach(i => { newList.push(i.date) })
      this.$store.commit('updateEventDatePublicMulti', newList)
    },
    sortFunc (a, b) {
      var d1 = (a.date === '') ? new Date('2099/12/31 23:59:59').getTime() : a.date
      var d2 = (b.date === '') ? new Date('2099/12/31 23:59:59').getTime() : b.date
      return new Date(d1) - new Date(d2)
    }
  },

  computed: {
    ...binder,
    eventEndDate () {
      // ソート
      this.endDate.sort(this.sortFunc)
      lecturer.eventEndDate(this)
      return '最終開催日の23:59まで掲載されます。'
    }
  }
}
</script>



// WEBPACK FOOTER //
// EventInput.vue?f64021fc